<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"><span><span style=" font-weight: normal; font-style: normal; font-size: 12.92em; color: #7096CE;">Biloxi</span></span></p>
<p class="P_div_frame-2"><span><img alt="14840.jpg" class="frame-4" id="a_14840" src="14840.jpg" style=" max-width: 100%; max-height: 100%;"/></span></p>
<p class="P_Basic-Paragraph_para-style-override-2__And__Centre_Alignment"><span> </span></p>
<p class="P_Basic-Paragraph_para-style-override-2__And__Centre_Alignment"><span><span style=" font-weight: normal; font-style: normal; font-size: 1.00em; color: #000000;">Barbara Sillery</span></span></p>
<p class="P_div_frame-2"><span> </span></p>
<p class="P_div_frame-2"><span><img alt="" src="image1.jpg" style=" max-width: 100%; max-height: 100%;"/></span></p>
<p class="P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment"><span><span style=" font-style: normal; font-size: 0.83em;">PELICAN PUBLISHING COMPANY</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-8__And__Centre_Alignment"><span><span style=" font-style: normal; font-size: 0.83em;">Gretna 2015</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?7a3bf059